if (!customElements.get('ys-trust-benefits')) {
  customElements.define('ys-trust-benefits', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      for (const trigger of this.querySelectorAll('[data-trust-open]')) {
        const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!(dialog instanceof HTMLDialogElement) || !dialog.showModal) continue;
        const fallback = this.querySelector(`[data-trust-fallback="${dialog.id}"]`);
        trigger.hidden = false;
        if (fallback) fallback.hidden = true;
        trigger.addEventListener('click', () => {
          if (document.querySelector('dialog[open], cart-drawer[open], x-drawer[open], newsletter-popup[open]')) return;
          this.activeTrigger = trigger;
          this.ownsLock = !document.documentElement.classList.contains('lock');
          dialog.showModal();
          document.documentElement.classList.add('lock');
          dialog.querySelector('[data-trust-close]')?.focus({ preventScroll: true });
        }, options);
        dialog.querySelector('[data-trust-close]')?.addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const stops = [...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')].filter(element => element.getClientRects().length);
          const first = stops[0], last = stops.at(-1);
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }, options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          this.releaseLock();
          if (this.activeTrigger?.isConnected) this.activeTrigger.focus({ preventScroll: true });
          this.activeTrigger = null;
        }, options);
      }
    }
    releaseLock() {
      if (this.ownsLock && !document.querySelector('dialog[open], cart-drawer[open], x-drawer[open], newsletter-popup[open]')) document.documentElement.classList.remove('lock');
      this.ownsLock = false;
    }
    disconnectedCallback() {
      for (const dialog of this.querySelectorAll('dialog[open]')) dialog.close();
      this.releaseLock();
      this.controller?.abort();
    }
  });
}
